"use strict";import{html as a}from"@cisco-u/base";export function circle({height:e=280,width:l=280,hidden:t=!1,title:i="",fill:r="#C3C4C5"}={}){return a`<svg
    width=${l}
    height=${e}
    viewBox="0 0 280 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${t?"true":"false"}"
    aria-label="${i}"
  >
    <circle cx="140" cy="140" r="140" fill=${r} />
  </svg>`}
//# sourceMappingURL=circle.js.map
